import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import cn from 'classnames'
import { useTranslation } from '@egw/i18n'
import styles from './loader.module.css'

export const BankName: FC<{
  bankName: string | undefined
  isFetching: boolean
}> = ({ bankName, isFetching }) => {
  const { t } = useTranslation('features-enrollment')

  return (
    <div className="flex flex-row mt-1">
      <div className="flex flex-row gap-2.5 items-center">
        {isFetching ? (
          <>
            <div
              className={cn('box-border rounded-[50%] border-b-transparent border-[.15rem] border-green-400', {
                [styles['loader-animation']]: true,
              })}
              style={{
                width: '1rem',
                height: '1rem',
              }}
            />
            <p className="text-green-600 text-xs font-semibold">{t('manual_link.searching')}</p>
          </>
        ) : null}
        {!isFetching && bankName ? (
          <>
            <CheckCircleIcon className="fill-green-400" width="1rem" height="1rem" />
            <p className="text-green-600 text-xs font-semibold fs-exclude">{bankName}</p>
          </>
        ) : null}
      </div>
    </div>
  )
}
